export default __webpack_public_path__ + "static/media/icon.4161e4f8.png";